export const state = {
    workProcesses: [],
    workProcessesAvailable: [],
    tasks: {},
    currentPage: 1,
    totalPages: 1,
    totalPagesAvailable: 1,
    itemsPerPage: 10,
    loading: false,
    error: null,
    vehicleModels: [],
    users: []
}
